(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => initPDTTabs());
document.addEventListener('shopify:section:load', () => initPDTTabs());
function initPDTTabs() {
  document.querySelectorAll('[data-pdt-tabs]').forEach((el) => {
    const btns = el.querySelectorAll('.pdt-tab-btn');
    const panels = el.querySelectorAll('.pdt-panel');
    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        btns.forEach((b) => {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        });
        panels.forEach((p) => p.classList.remove('active'));
        btn.classList.add('active');
        btn.setAttribute('aria-selected', 'true');
        const panel = el.querySelector(`[data-panel="${btn.dataset.tab}"]`);
        if (panel) panel.classList.add('active');
      });
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-product-carousel"] && !Shopify.designMode) return;
  try {
    
const VPC = {
  init() {
    document.querySelectorAll('[data-vpc]').forEach((el) => {
      new VPC.Carousel(el);
    });
  },
};

VPC.Carousel = class {
  constructor(root) {
    this.root = root;
    this.viewport = root.querySelector('.vpc-viewport');
    this.track = root.querySelector('.vpc-track');
    this.slides = this.track ? [...this.track.children] : [];
    this.prevBtn = root.closest('.section')?.querySelector('.vpc-arrow--prev');
    this.nextBtn = root.closest('.section')?.querySelector('.vpc-arrow--next');
    this.currentIndex = 0;
    this.autoplayTimer = null;
    this.isPaused = false;

    if (this.slides.length === 0) return;

    this.updateSlideWidth();
    this.bindEvents();
    this.updateArrows();

    const autoplaySpeed = this.root.getAttribute('data-vpc-autoplay');
    if (autoplaySpeed) {
      this.autoplaySpeed = parseInt(autoplaySpeed, 10) * 1000;
      this.pauseOnHover = this.root.hasAttribute('data-vpc-pause-on-hover');
      this.startAutoplay();
    }

    new ResizeObserver(() => this.updateSlideWidth()).observe(this.viewport);
  }

  updateSlideWidth() {
    this.slideWidth = this.slides[0]?.getBoundingClientRect().width || 0;
    this.gap = parseInt(getComputedStyle(this.root).getPropertyValue('--vpc-gap')) || 12;
    this.columns = this.getColumns();
    this.maxIndex = Math.max(0, this.slides.length - this.columns);

    if (this.currentIndex > this.maxIndex) {
      this.currentIndex = this.maxIndex;
    }
    this.scrollToIndex(this.currentIndex, false);
    this.updateArrows();
  }

  getColumns() {
    return window.innerWidth <= 749
      ? parseInt(this.root.style.getPropertyValue('--vpc-columns-mobile')) || 2
      : parseInt(this.root.style.getPropertyValue('--vpc-columns')) || 4;
  }

  bindEvents() {
    this.prevBtn?.addEventListener('click', () => this.prev());
    this.nextBtn?.addEventListener('click', () => this.next());
  }

  prev() {
    if (this.currentIndex <= 0) return;
    this.currentIndex = Math.max(0, this.currentIndex - this.columns);
    this.scrollToIndex(this.currentIndex);
    this.updateArrows();
    this.resetAutoplay();
  }

  next() {
    if (this.currentIndex >= this.maxIndex) return;
    this.currentIndex = Math.min(this.maxIndex, this.currentIndex + this.columns);
    this.scrollToIndex(this.currentIndex);
    this.updateArrows();
    this.resetAutoplay();
  }

  scrollToIndex(index, smooth = true) {
    if (!this.track) return;
    const offset = index * (this.slideWidth + this.gap);
    this.track.style.transform = `translateX(-${offset}px)`;
    this.track.style.transition = smooth ? 'transform 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'none';
  }

  updateArrows() {
    if (this.prevBtn) this.prevBtn.disabled = this.currentIndex <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
  }

  startAutoplay() {
    this.autoplayTimer = setInterval(() => {
      if (this.isPaused) return;
      if (this.currentIndex >= this.maxIndex) {
        this.currentIndex = 0;
        this.scrollToIndex(0);
        this.updateArrows();
      } else {
        this.next();
      }
    }, this.autoplaySpeed);

    if (this.pauseOnHover) {
      this.root.addEventListener('mouseenter', () => { this.isPaused = true; });
      this.root.addEventListener('mouseleave', () => { this.isPaused = false; });
    }
  }

  resetAutoplay() {
    if (!this.autoplayTimer) return;
    clearInterval(this.autoplayTimer);
    this.startAutoplay();
  }
};

document.addEventListener('DOMContentLoaded', () => VPC.init());
document.addEventListener('shopify:section:load', () => VPC.init());

  } catch(e) { console.error(e); }
})();
})();
